import {
  AUTH_LOGIN,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_ERROR,
  AUTH_LOGOUT,
  AUTH_UPDATE_USER,
  AUTH_PASSWORD_CHANGE_FORM_DATA_REQUEST,
  AUTH_PASSWORD_CHANGE_FORM_DATA_ERROR,
  AUTH_PASSWORD_CHANGE_FORM_DATA_SUCCESS,
  AUTH_PASSWORD_CHANGE_SUCCESS,
  AUTH_PASSWORD_CHANGE_ERROR,
  AUTH_PASSWORD_REQUEST_SUCCESS,
  AUTH_PASSWORD_REQUEST_ERROR,
  AUTH_SET_AGENCY_SUCCESS
} from '@constants/action-types';
import initialState from '../store/initial-state';

const authReducer = (state = initialState.auth, action) => {
  switch (action.type) {
  case AUTH_UPDATE_USER: {
    return { ...state, user: { ...state.user, ...action.payload } };
  }
  case AUTH_LOGIN: {
    return {
      ...state,
      pending: true,
      valid: false,
      errors: []
    };
  }
  case AUTH_LOGIN_SUCCESS: {
    return {
      ...state,
      pending: false,
      valid: true
    };
  }
  case AUTH_LOGIN_ERROR: {
    return {
      ...state,
      pending: false,
      valid: false,
      errors: { ...state.errors, ...action.payload.response.data }
    };
  }
  case AUTH_PASSWORD_REQUEST_SUCCESS:
    return { ...state, user: { ...state.user, requestedReset: { ...action.payload } } };
  case AUTH_PASSWORD_REQUEST_ERROR:
    return { ...state, user: { ...state.user, requestedReset: { ...action.error } } };
  case AUTH_PASSWORD_CHANGE_FORM_DATA_REQUEST: {
    const {userPk, token} = action;
    return { ...state, user: { ...state.user, passwordChangeFormData: {
      ...state.user.passwordChangeFormData,
      userPk,
      token
    }}};
  }
  case AUTH_PASSWORD_CHANGE_FORM_DATA_ERROR: {
    const {status, data} = action.error;
    return { ...state, user: { ...state.user, passwordChangeFormData: {
      ...state.user.passwordChangeFormData,
      status,
      data
    }}};
  }
  case AUTH_PASSWORD_CHANGE_FORM_DATA_SUCCESS:{
    const {status, data} = action.payload;
    return { ...state, user: { ...state.user, passwordChangeFormData: {
      ...state.user.passwordChangeFormData,
      status,
      data
    }}};
  }
  case AUTH_PASSWORD_CHANGE_SUCCESS:
    return { ...state, user: { ...state.user, passwordChangeData: { ...action.payload } } };
  case AUTH_PASSWORD_CHANGE_ERROR:
    return { ...state, user: { ...state.user, passwordChangeData: { ...action.error } } };
  case AUTH_SET_AGENCY_SUCCESS:
    return { ...state, user: { ...state.user, agencyId: action.agencyId } };
  case AUTH_LOGOUT: {
    return {
      ...state,
      valid: false
    };
  }
  default:
    return state;
  }
};

export default authReducer;
